export function getPercentage(total: number, value: number): number {
  const percent = value/total * 100
  const min = 0.00
  return isNaN(percent) ? min : percent
}